import ar from './ar.json'
import cs from './cs.json'
import de from './de.json'
import en from './en.json'
import es from './es.json'
import fr from './fr.json'
import hi from './hi.json'
import id from './id.json'
import it from './it.json'
import nl from './nl.json'
import pl from './pl.json'
import pt from './pt.json'
import ru from './ru.json'
import sk from './sk.json'
import tr from './tr.json'
import ur from './ur.json'

export const issuesLang = {ar, cs, de, en, es, fr, hi, id, it, nl, pl, pt, ru, sk, tr, ur}
